import { AppUtil, EnvUtil, HttpUtil, IReport, StringUtil } from 'kuaidong-lib'
import { UserInfo, UserTeacherId, UserRoleInfo } from 'kuaidong-model'

export class AUser {
  public static async loginByH5Token(): Promise<UserTeacherId> {
    if (EnvUtil.isSaas()) {
      return AppUtil.httpGET(`/account/login_by_h5token`, {}, {}, true)
    }
    if (EnvUtil.isAgency()) {
      return AppUtil.httpGET('/tr/coach/user/login_by_h5token')
    }
    if (EnvUtil.isOperation()) {
      return {}
    }
    return AppUtil.httpGET(`${process.env.VUE_APP_CRAZYROPE_MANAGE_API}/account/login_by_h5token`, {}, {}, true)
  }

  /**
   * 判断是否是多孩账户下的子账户
   * @returns {boolean} 是否为子账号
   */
  public static async checkIsSubAccount(): Promise<boolean> {
    const resp = await AppUtil.httpGET('/account/login_sub_account')
    return resp.is_sub_account
  }

  public static async getUserInfo(): Promise<UserInfo> {
    return AppUtil.httpGET('/account/user_info')
  }

  public static async feedback(feedback: { message: string; rate: number }): Promise<void> {
    return AppUtil.httpPOST('/user/feedback', feedback)
  }

  public static async getDrillReport(drill_record_id: string): Promise<IReport> {
    return AppUtil.httpGET(
      process.env.VUE_APP_CRAZYROPE_API + '/user/drill_report_info',
      { drill_record_id },
      {},
      false,
      false
    )
  }

  public static async getRoleInfo(): Promise<UserRoleInfo> {
    return AppUtil.httpGET('/account/role_info')
  }

  /**
   * 判断用户是否绑定了微信openid
   * 一定要登录之后才能调用
   */
  public static async getUserWxBindFlag(): Promise<{ bind_flag: boolean }> {
    return AppUtil.httpGET('/ttts/wx_bind_user_info')
  }

  /**
   * 构造一个绑定用户的流程, 需要redirect 过去， 然后微信会回调到指定的returnBackUrl
   * 一定要登录之后才能调用， 后端会绑定之后callback 回来
   * 没有登陆的机制，只能传token过去, XXX
   */
  public static buildWxBindUrl(returnBackUrl: string, token: string): string {
    const url = HttpUtil.buildFullUrl('/wx_web/ttts/oauth_callback_bind_user')
    return StringUtil.appendQueryString2Url(
      url,
      StringUtil.buildQueryString({
        target: returnBackUrl,
        token,
      })
    )
  }

  public static async bindWxUserOpenId(openid: string): Promise<void> {
    return AppUtil.httpPOST('/ttts/wx_bind_user', { openid })
  }
}
